<!-- Copyright (c) 2022-2024, NVIDIA CORPORATION & AFFILIATES. All rights reserved. -->

<template>
    <transition name="fade">
        <h4 id="status" :key="message">{{message}}</h4>
    </transition>
</template>
<script>
import Cookies from 'js-cookie';

import socketIOClient from '../util/socketIOClient';

export default {
    name: 'StatusMessage',

    props: {
        statusId: String,
    },

    data() {
        return {
            message: 'Loading',
            progress: 1,
            socket: undefined,
            updateInterval: undefined,
        };
    },

    async mounted() {
        try {
            this.socket = await socketIOClient(`/${this.statusId}`);
            if (!this.socket.connected) {
                this.socket.disconnect();
                throw new Error('Unable to open websocket');
            }
        } catch (err) {
            console.error(err);
            this.message = 'Failed to receive updates from the server. Please try again. ';
            this.message += 'If the error continues, please contact us at air-support@nvidia.com.';
            return;
        }
        this.socket.on('json', data => { this.handleUpdate(data); });
        this.updateInterval = setInterval(() => {
            this.socket.emit('ask_update', '');
        }, 1000);
    },

    destroyed() {
        this.socket.disconnect();
        clearInterval(this.updateInterval);
    },

    methods: {
        handleUpdate(data) {
            if (data.artifacts) {
                this.$emit('data', data);
                return;
            }
            this.message = data.message;
            if (data.progress > this.progress) {
                this.$emit('progress', data.progress);
            }
            this.progress = data.progress;
            if (data.cookie) {
                Cookies.set('sessionid', data.cookie);
            }
            if (data.status === 'done') {
                this.message = undefined;
                clearInterval(this.updateInterval);
                this.socket.emit('ask_artifacts', '');
            }
        },
    },
};
</script>
